module.exports = __webpack_public_path__ + "Flaticon.c958b4231c4b01be85f6.ttf";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/flaticon/Flaticon.ttf
// module id = ../../../../../src/assets/vendors/base/fonts/flaticon/Flaticon.ttf
// module chunks = styles